import { h } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';

import FieldBase from 'components/editor/settings/fieldBase';
import Autocomplete from 'components/dropdown/autocomplete';

import s from 'components/editor/settings/autocompleteField.sss';

export default class AutocompleteField extends FieldBase {
	s = s;

	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	get labelFor() {
		return null;
	}

	onChange(e) {
		this.props.onChange?.(e);
		if (!this.props.path) return;
		jsonPointer.setDeep(Store.get().data, this.props.path, e.target.value);
	}

	renderField() {
		const props = this.props;
		return (
			<Autocomplete
				class={s.field}
				align={props.align || 'full'}
				name={this.state.id}
				value={this.value}
				allowEmpty
				placeholder={this.placeholder}
				preText={props.preText}
				initialValue={props.initialValue}
				disabled={this.disabled || this.readonly}
				onChange={this.onChange}
				onInput={props.onInput}
				autofocus={props.autofocus}
				allowClear={props.allowClear}
			>
				{this.props.children}
			</Autocomplete>
		);
	}
}
